import { render, staticRenderFns } from "./AdditionalDetails.vue?vue&type=template&id=2dbaa20b"
import script from "./AdditionalDetails.vue?vue&type=script&lang=js"
export * from "./AdditionalDetails.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDetails.vue?vue&type=style&index=0&id=2dbaa20b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports